import React, { useState, useEffect } from 'react';
import { Empty, Table, message, Card, Typography, Collapse, Divider, Row, Col, Spin, Popover, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from "react-router-dom"
import { useExcryptedNavigation, ExchangeCurrency } from '../Filters/FilterConditions';
import { generateDynamicColumns, generateUsersTableData } from '../Pages/AllTableColumns/AccountTable';
import { FetchDealByEntity } from "../../../Api/Services/CommonApiService";
import { FetchAccountDetails } from "../../../Api/Services/AccountApiService";
import { Cards } from '../../../components/cards/frame/cards-frame';
import { AccountsIcon } from '../../../components/Icons/Icons';
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { getAllCustomFieldByCompanyAndEntity } from '../../../Api/Services/CustomeUIApiService';

const { Text } = Typography;
const { Panel } = Collapse;

const AccountTable = ({ UrlId, listingType, listingValues, setSelectedKeys, displayData, page, queryAction, refreshTrigger, tabKey }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const localData = useSelector((state) => state.localRedux);
  const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'accounts')?.customEntityId
  const ProfileData = localData.profile
  const profile = ProfileData
  const companyProfile = localData.company
  const defaultCurrency = localData.currency
  const ConvertRate = defaultCurrency?.exchangeRate;
  const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
  function convertAndFormatDateTime(dateTime, company, profile) {
    if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
    const extractTimezoneName = (tzStr) => {
      const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
      return match ? match[1] : "";
    };
    const fromTimezone = extractTimezoneName(company?.timeZone);
    const toTimezone = extractTimezoneName(profile?.timeZone);
    if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
      console.warn("Invalid timezone provided");
      return "";
    }
    const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
    const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
    const formattedDate = converted.format(dateFormat);
    // const rawTime = converted.format("HH:mm");
    // const formattedTime = convertTime(rawTime, profile?.timeFormat);

    return formattedDate
  }
  const [account, setAccount] = useState()
  const [sortedInfo, setSortedInfo] = useState()
  const [checkboxValues, setCheckboxValues] = useState()
  const accounttype = "ACCOUNT"
  const [openPage, setOpenPage] = useState(Array(account?.length).fill(false));
  const handleOpenPageChange = (index) => {
    const newPopoverOpenStates = [...openPage];
    newPopoverOpenStates[index] = !newPopoverOpenStates[index];
    setOpenPage(newPopoverOpenStates);
  };
  const { ExcryptedNavigation } = useExcryptedNavigation();
  const ViewDetailPage = (id, entity) => {
    ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
  }
  function formatDate(value, profile) {
    if (!value) return "";
    const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
    return moment(value).format(format);
  }
  async function getAllAccounts(listingValue) {
    try {
      const SortedData = listingValue.sort((a, b) => b.account_id - a.account_id);
      const transformedData = await Promise.all(
        SortedData.map(async (item) => {
          const transformedCustomFields = await Promise.all(
            (item.customFieldValues ?? []).map(async (attr) => {
              const fieldConfig = checkboxValues.find(field => field.id === attr.fieldId);
              if (!fieldConfig) return attr;
              let transformedValue = attr.value;
              if (fieldConfig.fieldType === "Currency") {
                const currecnyData = attr.value ? await ExchangeCurrency(Number(attr.value), ConvertRate) : null
                transformedValue = currecnyData
                  ? Number(currecnyData?.toFixed(CurencyDecimalPlace))
                  : 0;
              } else if (fieldConfig.fieldType === "Date") {
                transformedValue = attr.value
                  ? formatDate(attr.value, profile)
                  : attr.value;
              }
              return {
                ...attr,
                value: transformedValue,
              };
            })
          );
          return {
            ...item,
            created_at: item.created_at ? convertAndFormatDateTime(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile) : "",
            modified_at: item.modified_at ? convertAndFormatDateTime(item.modified_time ? `${item.modified_at} ${item.modified_time}` : item.modified_at, companyProfile, profile) : "",
            customFieldValues: transformedCustomFields,
          };
        })
      );
      setAccount(transformedData)
    } catch (error) {
      message.error(error);
    }
  }
  async function getCompetitionData(params) {
    try {
      const competitionArray = params.split(',').map(item => Number(item.trim()));
      const results = await Promise.all(
        competitionArray.map(async (competitionId) => {
          const responseData = await FetchAccountDetails(competitionId)
          const Response = responseData.data
          return { ...Response, DataPermission: { isPresent: responseData.allow } };
        })
      );
      setAccount(results);
    } catch (error) {
      message.error(error);
    }
  }
  async function AllAccount(type, id) {
    try {
      if (type === "Task") {
        const response = await FetchDealByEntity(id, "Account")
        const SortedData = response.sort((a, b) => b.account_id - a.account_id);
        const dataWithCurrency = await Promise.all(
          SortedData.map(async item => {
            return {
              ...item,
              DataPermission: { isPresent: item.allow }
            };
          })
        );
        setAccount(dataWithCurrency);
      }
    } catch (error) {
      message.error(error);
    }
  }
  const [states, setStates] = useState({
    selectedRows: [],
    selectedRowKeys: [],
  });
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setStates({ ...states, selectedRowKeys, selectedRows });
      setSelectedKeys(selectedRowKeys)
    },
    getCheckboxProps: (record) => {
      const permission = record.SharingData
      const AccountData = record?.AccountDataForPermission
      if (AccountData?.approved_for !== "None") {
        return { disabled: true };
      }
      // Only apply permission checks for these actions
      if (["Update", "OwnerChange", "Delete", "Sharing", "Task", "Email"].includes(queryAction)) {
        if (queryAction === "Task" || queryAction === "Email" || queryAction === "Sharing" || queryAction === "OwnerChange") {
          return {
            disabled: AccountData?.account_type_name !== "Customer"
          };
        }
        if (queryAction === "Sharing") {
          return { disabled: record.userId !== profile.userId };
        }
        if (!permission) return { disabled: false }; // Full access if no sharingPermission
        if (["Update", "OwnerChange"].includes(queryAction)) {
          return { disabled: !permission.includes("Update") };
        }
        if (queryAction === "Delete") {
          return { disabled: !permission.includes("Delete") };
        }

        // if (queryAction === "Sharing") {
        //     return { disabled: !permission.includes("Sharing") };
        // }
      }
      return { disabled: false };
    }
  };
  const handleTableChange = async (_, _1, sorter) => {
    setSortedInfo(sorter)
  }
  const dynamicColumns = generateDynamicColumns(checkboxValues, ViewDetailPage, sortedInfo, defaultCurrency);
  const usersTableData = generateUsersTableData(account, checkboxValues, defaultCurrency);
  async function getColumnConfig() {
    try {
      const allFieldsRaw = await getAllCustomFieldByCompanyAndEntity(ENTITY_ID);
      const allFields = [...allFieldsRaw].sort((a, b) => {
        if (a.fieldGroupSortOrder !== b.fieldGroupSortOrder) {
          return a.fieldGroupSortOrder - b.fieldGroupSortOrder;
        }
        return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
      });
      const structure = allFields.reduce((acc, field) => {
        if (field.fieldVisible === 'No') return acc;
        if (field.fieldKey === "lastName") return acc;
        if (field.fieldType === "FileUpload") return acc;
        if (field.fieldType === "MultiFileUpload") return acc;
        if (field.fieldKey === "firstName") {
          acc.push({
            isChecked: true,
            id: field.fieldId,
            name: "Name",
            entityId: field.entityId,
            fieldKey: "name",
            fieldType: field.fieldType,
            dropdownId: field.dropdownId,
            dropdownType: field.dropdownType,
            customFieldType: field.customFieldType,
          });
          return acc;
        }
        acc.push({
          isChecked: true,
          id: field.fieldId,
          name: field.fieldLabel,
          entityId: field.entityId,
          fieldKey: field.fieldKey,
          fieldType: field.fieldType,
          dropdownId: field.dropdownId,
          dropdownType: field.dropdownType,
          customFieldType: field.customFieldType,
        });
        return acc;
      }, []);
      structure.push(
        {
          isChcked: true,
          id: "account_score",
          name: "Account Score",
          entityId: null,
          fieldKey: "account_score",
          fieldType: "Number",
          dropdownId: null,
          dropdownType: null,
          customFieldType: null,
        },
        {
          isChecked: true,
          id: "created_at",
          name: "Created Date",
          entityId: null,
          fieldKey: "created_at",
          fieldType: "Date",
          dropdownId: null,
          dropdownType: null,
          customFieldType: null,
        },
        {
          isChecked: true,
          id: "modified_at",
          name: "Modified Date",
          entityId: null,
          fieldKey: "modified_at",
          fieldType: "Date",
          dropdownId: null,
          dropdownType: null,
          customFieldType: null,
        }
      );
      setCheckboxValues(structure)
    } catch (error) {
      message.error(error);
    }
  }
  useEffect(() => {
    if (listingType === "Query") {
      getColumnConfig()
    }
  }, [listingType, listingValues])
  useEffect(() => {
    if (listingType === "Query" && checkboxValues.length) {
      getAllAccounts(listingValues)
    }
  }, [checkboxValues])
  useEffect(() => {
    if (refreshTrigger === tabKey) {
      if (listingType !== "Query" && page !== "Deal") {
        if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
          AllAccount("Lead", UrlId[1])
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
          AllAccount("Deal", UrlId[1])
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
          AllAccount("Contact", UrlId[1])
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
          AllAccount("Account", UrlId[1])
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK") {
          AllAccount("Task", UrlId[1])
        }
      }
      if (page === "Deal") {
        if (displayData?.competition) {
          getCompetitionData(displayData?.competition)
        } else {
          setAccount([])
        }
      }
    }
  }, [UrlId, displayData, refreshTrigger, tabKey])
  function convertAndFormatDateTime2(dateTime, company, profile) {
    if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";

    const extractTimezoneName = (tzStr) => {
      const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
      return match ? match[1] : "";
    };

    const fromTimezone = extractTimezoneName(company?.timeZone);
    const toTimezone = extractTimezoneName(profile?.timeZone);

    if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
      console.warn("Invalid timezone provided");
      return "";
    }

    const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone);

    // Check if the date is today in the same target timezone
    const today = moment.tz(toTimezone).startOf('day');
    const isToday = converted.isSame(today, 'day');

    if (isToday) {
      return "Today";
    }
    const formattedDate = converted.format("MMM DD, YYYY");
    return formattedDate
  }
  const TableSkeleton = () => {
    const skeletonRowStyle = {
      padding: '13px 20px',
      height: '68px',
      borderBottom: '1px solid #f0f0f0',
    };
    return (
      <div>
        {Array.from({ length: 5 }).map((_, idx) => (
          <div key={idx} style={skeletonRowStyle}>
            <Skeleton
              avatar paragraph={{ rows: 2, width: '100%' }}
              active
              title={false}
            />
          </div>
        ))}
      </div>
    );
  };
  const LoadingCiolums = [
    {
      title: (
        <Skeleton
          paragraph={{ rows: 1, width: '100%' }}
          active
          title={false}
        />
      ),
      dataIndex: 'name',
      key: 'name',
    },]
  return (
    <>
      {listingType === "Query" ?
        // <div className="full-width-table" style={{ width: "100%" }} >
        <div className='Listing-PagePadding' style={{ width: "100%" }}>
          <Cards headless bodyStyle={{ borderRadius: '10px' }}>
            <div className="table-bordered leaderboard-table table-responsive">
              <Table
                showSorterTooltip={false}
                rowSelection={rowSelection}
                dataSource={usersTableData}
                columns={!account ? LoadingCiolums : dynamicColumns}
                locale={{
                  emptyText: !account ? (
                    <TableSkeleton rows={5} />
                  ) :
                    account?.length === 0 && <Empty />
                }}
                onChange={handleTableChange}
                pagination={{
                  defaultPageSize: 5,
                  total: usersTableData.length,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                }} />
            </div>
          </Cards>
        </div>
        :
        <>
          {account ? (account?.length > 0 ?
            account.map((item, index) => {
              const formattedTimeDifference = convertAndFormatDateTime2(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile)
              return (
                <div key={index} style={{ marginBottom: 15 }}>
                  <Card className="DetailsTabCard">
                    <Collapse bordered={false} className="DetailsTabCollapse">
                      <Panel
                        header={
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <AccountsIcon height={16} width={16} marginRight={5} />
                            <Text strong>{item.account_name} ({item.account_number})</Text>
                          </div>
                        }
                        key="1"
                        extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}
                          </div>
                          {item.DataPermission.isPresent &&
                            <Popover
                              placement="bottom"
                              content={
                                <div>
                                  <div className="text_icon newHover-class"
                                    role="button"
                                    tabIndex={0} title='View Details'
                                    onClick={() => {
                                      ViewDetailPage(item.account_id, accounttype)
                                      handleOpenPageChange(index)
                                    }}
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter' || event.key === ' ') {
                                        ViewDetailPage(item.account_id, accounttype)
                                        handleOpenPageChange(index)
                                      }
                                    }}
                                    aria-label='view'>
                                    <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                  </div>
                                </div>
                              }
                              trigger="hover"
                              open={openPage[index]}
                              onOpenChange={() => handleOpenPageChange(index)}
                            >
                              <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                            </Popover>}
                        </div>}
                      >
                        <Divider style={{ margin: 0 }} />
                        <div style={{ marginTop: 10 }}>
                          <Text type="secondary">{item.description && item.description !== "" ? <CustomHtmlParser html={item.description} key={index} page="Previewss" /> : "Account Description"}</Text>
                        </div>
                        <Divider style={{ margin: "10px 0" }} />
                        <Row gutter={16}>
                          <Col span={7} style={{
                            borderRight: "1px solid #dddddd"
                          }}>
                            <Text type="secondary" className='RightSide-Lable'>Industry</Text>
                            <br />
                            <Text>{item.industry_name}</Text>
                          </Col>
                          <Col span={7} style={{
                            borderRight: "1px solid #dddddd"
                          }}>
                            <Text type="secondary" className='RightSide-Lable'>Account Type</Text>
                            <br />
                            <Text>{item.account_type_name}{(item.customer_status && item.customer_status !== "") ? "," : ""}</Text><br />
                            <Text>{item.customer_status}</Text>
                          </Col>
                          <Col span={10}>
                            <Text type="secondary" className='RightSide-Lable'>Country</Text>
                            <br />
                            <Text>{item.country}</Text>
                          </Col>
                        </Row>
                      </Panel>
                    </Collapse>
                  </Card>
                </div >
              )
            }) :
            <div style={{ padding: "10%" }}>
              <Empty />
            </div>
          ) :
            <div className="spin">
              <Spin />
            </div>
          }
        </>
      }
    </>
  );
}
AccountTable.propTypes = {
  queryAction: PropTypes.string.isRequired,
  listingType: PropTypes.string.isRequired,
  UrlId: PropTypes.array.isRequired,
  listingValues: PropTypes.array.isRequired,
  setSelectedKeys: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  displayData: PropTypes.object.isRequired,
  refreshTrigger: PropTypes.string.isRequired,
  tabKey: PropTypes.string.isRequired,
};
export default React.memo(AccountTable)